<div
	[class]="
		cn(
			size() === 'large' &&
				'aspect-square w-full sm:aspect-classic lg:aspect-video lg:h-[85vh] lg:max-h-200 lg:min-h-146',
			size() === 'medium' && 'h-[25rem] md:h-[30rem]',
			size() === 'small' && 'h-[17rem] md:h-[20rem]',
			'relative flex'
		)
	"
	data-test-id="hero-item"
>
	<div
		class="w-full grow-0 rounded sm:order-2 sm:mb-0 max-lg:h-webkit-fill-available"
	>
		<article
			[attr.aria-labelledby]="'slide-heading-' + indexNumber()"
			class="h-full"
		>
			@if (video()) {
				<div
					[class]="
						cn(
							size() === 'large' &&
								'aspect-classic w-full lg:aspect-[9/4] lg:h-[85vh] lg:max-h-200 lg:min-h-146',
							size() === 'medium' &&
								'h-[25rem] md:h-[30rem] lg:h-[33rem]',
							size() === 'small' &&
								'h-[17rem] md:h-[20rem] lg:h-[22rem]',
							'relative'
						)
					"
				>
					<vp-video
						[showControls]="false"
						[vimeoId]="video()?.vimeoId || 0"
						class="block origin-top scale-180 lg:scale-160 xl:scale-110"
					/>
				</div>
			} @else {
				@defer (hydrate on idle) {
					<picture class="absolute top-0 size-full">
						<source
							[srcset]="
								(heroImage().src
									| imageQuery: { width: 800, height: 600 }) +
								' 640w, ' +
								(heroImage().src
									| imageQuery
										: {
												width: 1280,
												height: 960,
										  }) +
								' 1024w, ' +
								(heroImage().src
									| imageQuery
										: {
												width: 1800,
												height: 1000,
										  }) +
								' 1440w, ' +
								(heroImage().src
									| imageQuery
										: {
												width: 2400,
												height: 1000,
										  }) +
								' 1920w, ' +
								(heroImage().src
									| imageQuery
										: {
												width: 3600,
												height: 1000,
										  }) +
								' 2880w'
							"
							sizes="100vw"
							type="image/webp"
						/>
						<img
							[attr.alt]="heroImage().alt || null"
							[attr.fetchpriority]="
								indexNumber() === 0 ? 'high' : 'auto'
							"
							[attr.loading]="
								useEagerLoading() && indexNumber() === 0
									? 'eager'
									: 'lazy'
							"
							[attr.role]="
								!heroImage().alt ? 'presentation' : null
							"
							[class]="
								cn(
									!isCustomImage() && 'bg-ui-25 object-none',
									imageError() && 'object-scale-down',
									'hero-item-image size-full'
								)
							"
							[height]="size() === 'large' ? 640 : 320"
							[src]="
								heroImage().src
									| imageQuery
										: {
												width: 1800,
												height:
													size() === 'large'
														? 1000
														: 300,
										  }
							"
							(error)="setImageFallback()"
							class="object-cover"
							data-test-class="carousel__image"
							decoding="async"
							width="800"
						/>
					</picture>
				} @placeholder {
					<div
						class="absolute top-0 flex size-full items-center justify-center"
					>
						<svg-icon
							class="size-10 animate-spin text-dark-quaternary md:size-16"
							data-test-id="loader"
							src="assets/icons/icon-spinner.svg"
						/>
					</div>
				}
			}
			<div
				class="absolute left-0 top-0 size-full bg-gradient-to-b from-[#000000CC] to-transparent to-25% md:to-50%"
			></div>
			@if (heading()) {
				<div
					class="hero-item-image-shadow absolute bottom-0 left-0 size-full bg-gradient-to-t from-[#000000CC] to-transparent to-75% md:to-50%"
				></div>
			}
			<div
				class="absolute top-0 size-full px-3 md:px-8"
				id="hero-container"
			>
				<div class="section-inner flex h-full items-end">
					<div
						[class]="
							cn(
								contentMargin() === 'large' && 'mb-32 lg:mb-40',
								contentMargin() === 'small' &&
									'mb-18 md:mb-20 lg:mb-[104px]',
								contentMargin() === 'none' &&
									'mb-8 md:mb-12 lg:mb-16',
								alignment() === 'center' && 'text-center',
								'z-10 flex w-full flex-col text-white'
							)
						"
					>
						@if (sticker()?.src) {
							<vp-image
								[class]="
									cn(
										alignment() === 'center' && 'mx-auto',
										'mb-4 size-16 md:size-20'
									)
								"
								[image]="{
									src: sticker()!.src,
									altText: sticker()?.altText,
									width: 160,
									height: 160,
								}"
								[sources]="[
									{
										min: null,
										max: sizes.md,
										width: 128,
										height: 128,
									},
									{
										min: sizes.md,
										max: null,
										width: 160,
										height: 160,
									},
								]"
							/>
						}
						@if (overline()) {
							<span
								class="text-shadow text-sm uppercase tracking-widest lg:text-base"
								data-test-id="overline"
							>
								{{ overline() }}
							</span>
						}
						<div
							[id]="'slide-heading-' + indexNumber()"
							class="text-shadow mb-0 font-display text-3xl children:lg:text-5xl children:lg:leading-tight"
						>
							@if (heading()) {
								<span class="block" data-test-id="heading">
									@if (headingType()) {
										<span
											[heading]="headingType()"
											class="mb-0 font-carousel"
											vc-heading
										>
											{{ heading() }}
										</span>
									} @else {
										<span class="font-carousel">
											{{ heading() }}
										</span>
									}
								</span>
							}
							<span
								class="block font-display font-carousel"
								data-test-id="subheading"
							>
								<ng-content select="vp-hero-item-sub-heading" />
							</span>
						</div>
						@if (link()?.url) {
							<vp-link
								[className]="
									cn(
										alignment() === 'center' &&
											'justify-center',
										'flex text-white no-underline visited:text-white hover:text-white'
									)
								"
								[link]="link()"
								class="text-shadow mt-4 text-base font-semibold outline-2 outline-offset-2 outline-white focus:rounded-md focus:outline md:text-lg"
							>
								{{ link().content }}
								<svg-icon
									class="ml-1 inline-block size-4 self-center fill-white"
									src="assets/icons/icon-chevron-right.svg"
								/>
							</vp-link>
						}
					</div>
				</div>
			</div>
		</article>
	</div>
</div>
